import React from 'react';
import BrandclubSideWidget from '../components/BrandclubSideWidget/index.js';

var BrandclubCashBack = function (_a) {
    var _b;
    var brandEntity = _a.brandEntity, LinkComponent = _a.LinkComponent;
    return (React.createElement(BrandclubSideWidget, { leftSideProps: {
            type: 'image',
            imageUrl: "https://media.brandclub.com/brandclub/image_asset/d2.png",
            imageLink: { id: '', displayName: '' },
        }, rightSideProps: {
            type: 'text',
            title: "Unlimited daily cash back",
            subtitle: "Earn real cash. No points. No gimmicks. You earn real cash back every time you shop and engage with ".concat((_b = brandEntity === null || brandEntity === void 0 ? void 0 : brandEntity.entity) === null || _b === void 0 ? void 0 : _b.name, "."),
            buttonText: '',
            buttonLink: { id: '', displayName: '' },
        }, LinkComponent: LinkComponent }));
};

export { BrandclubCashBack };
//# sourceMappingURL=index.js.map
